module.exports = __webpack_public_path__ + "static/media/countdownP.4a98bf76.jpg";